import { useStore } from '~/src/hooks/useMst';

const useUser = () => useStore().user;

export default useUser;
